import PropTypes from 'prop-types';
import React, { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { useQueryCourseProgress } from 'gql/queries/course';
import useModal from 'hooks/useModal';
import extract from 'helpers/extract';
import history from 'lib/history';

import CourseStudy from './CourseStudy';

const CourseStudyContainer = ({ course, ...props }) => {
  const { t } = useTranslation();
  const { isModalOpen, handleModalOpen, handleModalClose } = useModal();
  const { isLoading, data } = useQueryCourseProgress({
    variables: {
      courseId: course.id,
    },
  });
  const completeCourse = isLoading ? undefined : data.course;
  const [areOptionsOpen, setAreOptionsOpen] = useState(false);
  const handleOptionsToggle = useCallback((evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    setAreOptionsOpen((v) => !v);
  }, []);
  const validationSchema = useMemo(
    () =>
      yup.object().shape({
        wooflash: yup.boolean().default(true),
        onlyNew: yup.boolean().default(false),
        allRandom: yup.boolean().default(false),
        inOrder: yup.boolean().default(false),
      }),
    [],
  );
  const handleCourseStudy = useCallback(
    async (chapterId, setStatus, values) => {
      try {
        setStatus(null);
        const variables = extract(values, validationSchema);
        handleModalClose();
        const method = variables.wooflash
          ? 'wooflash'
          : variables.onlyNew
          ? 'new'
          : variables.allRandom
          ? 'random'
          : variables.inOrder
          ? 'order'
          : 'wooflash';
        const querystring = Object.entries({
          chapterId,
          method,
        })
          .filter(([, v]) => !!v)
          .map(([key, value]) => `${key}=${value}`)
          .join('&');
        history.push(`/study/${course?.id}?${querystring}`);
      } catch (err) {
        setStatus('500');
      }
    },
    [course, handleModalClose, validationSchema],
  );
  return (
    <CourseStudy
      course={completeCourse}
      handleCourseStudy={handleCourseStudy}
      handleModalClose={handleModalClose}
      handleModalOpen={handleModalOpen}
      handleOptionsToggle={handleOptionsToggle}
      isModalOpen={isModalOpen}
      areOptionsOpen={areOptionsOpen}
      t={t}
      validationSchema={validationSchema}
      {...props}
    />
  );
};

CourseStudyContainer.propTypes = {
  course: PropTypes.object.isRequired,
};

export default CourseStudyContainer;
